<template>
  <div>
    <div id="dropContainer"
         class="p-3 d-flex align-items-center form-control styled-input justify-content-center"
         style="min-height:150px; height:auto; "
         @dragover.prevent="dragoverHandler"
         @dragenter.prevent="enterHandler"
         @click.prevent="clickHandler"
         @drop.prevent="dropHandler">
      <img class="img-fluid" id="preview-img" v-show="preview" :src="imageUrl" alt="">
      <span v-show="!preview">{{ $t('message.drop_your_image_here') }}</span>
    </div>
    <input class="d-none file-input-field"
           :required="required"
           @change="changeHandler"
           :id="name"
           :name="name"
           type="file">
    <button @click.prevent="removeImage" type="button" class="d-block m-auto btn-sm small_btn small btn btn_small btn-danger" v-if="fileUrl">
      {{$t('message.delete')}}
    </button>
<!--    file: {{fileUrl}}-->
  </div>

</template>
<script>
  export default {
    data() {
      return {
        fileUrl: '',
        preview: this.imageUrl.length,
      }
    },
    props: {
      required: {
        Boolean,
        default() {
          return false
        }
      },
      imageUrl: {
        String,
        default() {
          return ''
        }
      },
      name: {
        String,
        default() {
          return 'files'
        }
      }
    },
    methods: {
      removeImage() {
        const fileInput = document.querySelector('.file-input-field');
        const img = document.querySelector('#preview-img');
        img.src = '';
        fileInput.value = '';
        this.preview = false;
        this.fileUrl = '';
      },
      changeHandler(evt) {
        // console.log('change', evt)
        const files = evt.target.files;
        const img = document.querySelector('#preview-img');
        let _vm = this;
        if (FileReader && files && files.length) {
          var fr = new FileReader();
          fr.onload = function () {
            img.src = fr.result;
            _vm.fileUrl = fr.result;
            // console.log('file', _vm.fileUrl)
          };

          fr.readAsDataURL(files[0]);
          this.preview = true;
        }

      },
      enterHandler(evt) {
        // console.log('enter handler', evt);
        // evt.preventDefault();
      },

      clickHandler(evt) {
        const fileInput = document.querySelector('.file-input-field');
        // console.log('click handler', evt)
        fileInput.click()
      },

      dragoverHandler(evt) {
        // console.log('dragover handler', evt)
      },

      dropHandler(evt) {
        // console.log('drop handler', evt);
        const files = evt.dataTransfer.files;
        const fileInput = document.querySelector('.file-input-field');
        const img = document.querySelector('#preview-img');
        fileInput.files = evt.dataTransfer.files;

        if (FileReader && files && files.length) {
          var fr = new FileReader();
          fr.onload = function () {
            // console.log('filereader result', fr.result)
            img.src = fr.result;
          };
          fr.readAsDataURL(files[0]);
          this.preview = true;
        }

        evt.preventDefault();
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/FileUpload.vue